import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteVendorCreationPopupContent.ContactInformation', {
    contactInformationSection: 'Contact information',
    email: 'Email',
    phone: 'Phone',
    altPhone: 'Alt phone',
    fax: 'Fax',
    inputPlaceholder: 'Enter value',
});
